import { render, staticRenderFns } from "./ResultsConfirmed.vue?vue&type=template&id=743a810c&scoped=true&"
import script from "./ResultsConfirmed.vue?vue&type=script&lang=ts&"
export * from "./ResultsConfirmed.vue?vue&type=script&lang=ts&"
import style0 from "./ResultsConfirmed.vue?vue&type=style&index=0&id=743a810c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743a810c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
